import { useState } from "react";
import { VmCostService } from "../../application/services/vmCostService";

const vmCostService = new VmCostService();

export const useVmCostByMonth = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [vmCosts, setVmCosts] = useState([]);

  const getVmCostsByMonthAndYear = async (year, month) => {
    setLoading(true);
    setError(null);
    try {
      const result = await vmCostService.getVmCostsByMonthAndYear(year, month);
      if (result.success) {
        setVmCosts(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getVmCostDetail = async (vmId, year, month) => {
    setLoading(true);
    setError(null);
    try {
      const result = await vmCostService.getVmCostDetail(vmId, year, month);
      if (result.success) {
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getVmCostsByServiceForVm = async (vmId, year, month) => {
    setLoading(true);
    setError(null);
    try {
      const result = await vmCostService.getVmCostsByServiceForVm(vmId, year, month);
      if (result.success) {
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getVmCostHistoryByDateRange = async (vmId, startDate, endDate) => {
    setLoading(true);
    setError(null);
    try {
      const result = await vmCostService.getVmCostHistoryByDateRange(vmId, startDate, endDate);
      if (result.success) {
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const checkMonthHasData = async (vmIds, year, month) => {
    try {
      for (const vmId of vmIds) {
        const result = await vmCostService.getVmCostDetail(vmId, year, month);
        if (result.success && result.data && result.data.totalCost > 0) {
          return true;
        }
      }
      return false;
    } catch (error) {
      console.error("Error checking month data:", error);
      return false;
    }
  };

  const getNewestMonthWithData = async (vmIds) => {
    const today = new Date();
    let checkYear = today.getFullYear();
    let checkMonth = today.getMonth();
    
    for (let i = 0; i < 12; i++) {
      if (checkMonth === 0) {
        checkMonth = 12;
        checkYear--;
      }
      const hasData = await checkMonthHasData(vmIds, checkYear, checkMonth);
      if (hasData) {
        return { year: checkYear, month: checkMonth };
      }
      checkMonth--;
    }
    
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    return {
      year: lastMonth.getFullYear(),
      month: lastMonth.getMonth() + 1
    };
  };

  return {
    getVmCostsByMonthAndYear,
    getVmCostDetail,
    getVmCostsByServiceForVm,
    getVmCostHistoryByDateRange,
    checkMonthHasData,
    getNewestMonthWithData,
    vmCosts,
    loading,
    error,
  };
};